import { useEffect, useRef } from 'react';
import { shallowEqual } from 'react-redux';

export function useChangeEffect<TDependency extends any[]>(
  reaction: () => void | (() => void),
  deps: TDependency,
  compare: (prev: TDependency, next: TDependency) => boolean = shallowEqual,
): void {
  const prevDepsRef = useRef<TDependency>(deps);
  const cleanupRef = useRef<void | (() => void)>();

  useEffect(() => {
    const prevDeps = prevDepsRef.current;

    if (compare(prevDeps, deps)) {
      return;
    }

    cleanupRef.current?.();
    cleanupRef.current = reaction();
    prevDepsRef.current = deps;
  });

  useEffect(() => {
    return () => {
      cleanupRef.current?.();
    };
  }, []);
}
